"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockHttpClient = void 0;
exports.mockHttpClient = {
    request: async (req) => await Promise.resolve({ data: req, config: { url: req.url }, headers: {} }),
};
//# sourceMappingURL=HttpClient.js.map